import { createLink } from '#imports'
import type { LinkSchema } from '@core/types'

export const useLinks = createSharedComposable(() => {
    const flags = useFeatureFlags()
    const { t } = useI18n()

    const frontpage = createLink(() => {
        return {
            to: {
                path: '/',
            },
        }
    })

    const signup = createLink(() => {
        if (flags.enableInternalAuth) {
            return {
                to: {
                    query: {
                        auth: 'signup',
                        step: '1',
                    },
                },
            }
        }

        return {
            to: {
                path: '/',
                hash: '#/signup',
            },
            options: {
                external: true,
            },
        }
    })

    const login = createLink(() => {
        if (flags.enableInternalAuth) {
            return {
                to: {
                    query: {
                        auth: 'login',
                    },
                },
            }
        }

        return {
            to: {
                path: '/',
                hash: '#/login',
            },
            options: {
                external: true,
            },
        }
    })

    const forgotPassword = createLink(() => {
        if (flags.enableInternalAuth) {
            return {
                to: {
                    query: {
                        auth: 'forgot-password',
                    },
                },
            }
        }

        return {
            to: {
                path: '/',
                hash: '#/forgot-password',
            },
            options: {
                external: true,
            },
        }
    })

    const payments = createLink(() => {
        return {
            to: { path: t('pages.deposit') } as LinkSchema['to'],
            external: true
        }
    })

    const support = createLink(() => {
        return {
            to: {
                name: 'kundeservice',
            },
        }
    })

    return {
        frontpage,
        signup,
        login,
        forgotPassword,
        payments,
        support,
    }
})
